import { useMutation, gql } from '@apollo/client'
import { MutationHookParams } from '../sharedTypes/types'

export interface CancelInviteResponse {
  cancelInvite: boolean
}

const CANCEL_INVITATION_MUTATION = gql`
  mutation CancelInviteMutation($id: Int!) {
    cancelInvite(id: $id)
  }
`

export const useCancelInviteMutation = (options?: MutationHookParams) => {
  const [mutation, { data, loading, error }] = useMutation<CancelInviteResponse>(
    CANCEL_INVITATION_MUTATION,
    options
  )

  const cancelInvite = async (id: number) => {
    const response = await mutation({
      variables: { id }
    })

    return response.data?.cancelInvite ?? false
  }

  return {
    cancelInvite,
    data,
    loading,
    error
  }
}
